import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getSkillsFromStore,
  addSkillToUser,
  filterSearchItem,
  getDraftSkills,
  deleteDraftSkill,
  clearDraft,
  retrieveFilteredSkill,
  changeActiveTab,
  retrieveAllTemplates,
  retrieveDraftByEmail,
  retrieveMySkills,
  setSelectedFilter,
  setUserEmail,
  setSelectedTemplate,
  setSearchQuery
} from "../../../../../redux/actions/skill";
import { changeMode } from "../../../../../redux/actions/appActions";
import { withRouter } from "react-router";
import { compose } from "redux";
import EmptyLoader from "../../../../../components/emptyLoader";
import Loader from "../../../../../components/loader";
import { notify } from "../../../../../redux/actions/snack";
import getColors from "../../../../../components/colors";
import MyDraftItem from "../MyDraftItem";
import { Pagination, Select, Modal, Tooltip, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const { Option } = Select;

class MyDraftSkills extends Component {
  constructor(props) {
    super(props);
    this.emailInputRef = React.createRef();
    this.state = {
      skills: [],
      filteredSkills: [],
      uniqueSkills: [],
      isLoading: true,
      isScrolling: false,
      hasMore: true,
      searchItem: "",
      backupSKills: [],
      checked: "all",
      activePage: 1,
      draftPage: 1,
      publishedPage: 1,
      itemsPerPage: 9,
      pendingPage: 1,
      userPage: 1,
      otherUserPage: 1,
      inAppPage: 1,
      userDocPage: 1,
      userOnPage: 1,
      webAutoPage: 1,
      blankPage: 1,
      skillSetPage: 1,
      importPage: 1,
      desktopPage: 1,
      workflowPage: 1,
      selectedTemplate: "",
      createdByOtherUser: false,
      userEmail: "",
      createdBy: "",
      isTemplateLodaing: true,
      displayContent: "",
      selectedTemplate: ""
    };
  }

  componentDidMount() {
    const email = this.props?.skillReducer?.userEmail
    const filter = this.props?.skillReducer?.selectedFilter
    const template = this.props?.skillReducer?.selectedTemplate
    if (filter === "published" || filter === "draft" || filter === "pending") {
      this.getFilteredSkill();
    } else if (filter === "CreatedBy Me") {
      this.handleUserSubmit();
    } else if (filter === "CreatedBy") {
      this.getSkillsByUserEmail();
    } else if (template === "In-App Walkthrough" || template === "Blank Template"
      || template === "UserDocumentation" || template === "WebAutomation"
      || template === "Import Data from Spreadsheet to Web App" || template === "Desktop Walkthrough"
      || template === "UserOnboarding" || template === "GenAi Automation"
    ) {
      this.getSkillsByTemplate();
    } else {
      this.getDraftSkill();
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    const { activePage, publishedPage, draftPage, pendingPage, userPage, otherUserPage, inAppPage, userDocPage, userOnPage, webAutoPage, blankPage, importPage, workflowPage } = this.state;
    if (activePage !== prevState.activePage) {
      this.getDraftSkill();
    }
    else if (
      publishedPage !== prevState.publishedPage ||
      draftPage !== prevState.draftPage ||
      pendingPage !== prevState.pendingPage
    ) {
      this.getFilteredSkill();
    }
    else if (
      inAppPage !== prevState.inAppPage ||
      blankPage !== prevState.blankPage ||
      userDocPage !== prevState.userDocPage ||
      userOnPage !== prevState.userOnPage ||
      webAutoPage !== prevState.webAutoPage ||
      importPage !== prevState.importPage ||
      workflowPage !== prevState.workflowPage
    ) {
      this.getSkillsByTemplate();
    } else if (userPage !== prevState.userPage) {
      this.handleUserSubmit();
    }
    else if (
      otherUserPage !== prevState.otherUserPage
    ) {
      this.getSkillsByUserEmail();
    }
  }

  getDraftSkill = async () => {
    const queryParams = new URLSearchParams(window.location.search);
    let page = parseInt(queryParams.get('page')) || 1;
    let data = { page };
    const userDraftSkill = await this.props.getDraftSkills(data);
    if (userDraftSkill) {
      if (userDraftSkill?.results) {
        this.setState({
          isLoading: false,
          skills: userDraftSkill.results,
          isScrolling: false,
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };


  getFilteredSkill = async () => {
    const filter = this.props?.skillReducer?.selectedFilter
    const queryParams = new URLSearchParams(window.location.search);
    let page = parseInt(queryParams.get('page')) || 1;
    let data = { page, filter };
    const filtered = await this.props.retrieveFilteredSkill(data);
    if (filtered) {
      if (filtered?.results?.length) {
        this.setState({
          isLoading: false,
          skills: filtered.results,
          isScrolling: false,
        });
        return page;
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  getSkillsByTemplate = async () => {
    this.setState({ createdBy: "" })
    const template = this.props?.skillReducer?.selectedTemplate
    try {
      let filter = template;
      const queryParams = new URLSearchParams(window.location.search);
      let page = parseInt(queryParams.get('page')) || 1;
      let data = { page, filter };
      const filtered = await this.props.retrieveFilteredSkill(data);
      if (filtered) {
        const content = `${template ? template : ""}`
        if (filtered?.results) {
          this.setState({
            displayContent: content,
            isLoading: false,
            skills: filtered.results,
            isScrolling: false,
            checked: 'byTemplate'
          });
        }
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false
        });
      }

    } catch (error) {
      console.error('Error fetching skills by template:', error);
      // Handle errors if needed
    }
  }

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);//setting the page parameter to the URL
    this.props.history.push({ search: queryParams.toString() });
  };

  handlePublishedPageChange = (pageNumber) => {
    this.setState({ publishedPage: pageNumber, isLoading: true }, () => {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set('page', pageNumber);
      window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
      this.getFilteredSkill(pageNumber);
    });
  }
 
  handleDraftPageChange = (pageNumber) => {
    this.setState({ draftPage: pageNumber, isLoading: true }, () => {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set('page', pageNumber);
      window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
      this.getFilteredSkill(pageNumber);
    });
  }


  handlePendingPageChange = (pageNumber) => {
    this.setState({ pendingPage: pageNumber, isLoading: true }, () => {
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set('page', pageNumber);
      window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
      this.getFilteredSkill(pageNumber);
    });
  }


  handleUserPageChange = (pageNumber) => {
    const filter = this.props?.skillReducer?.selectedFilter
    this.props.setSelectedFilter(filter)
    this.setState({ userPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.handleUserSubmit(pageNumber)
  };

  handleOtherUserPageChange = (pageNumber) => {
    this.setState({ otherUserPage: pageNumber, isLoading: true }, () => {
    });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByUserEmail(pageNumber)
  };

  handleInAppPageChange = (pageNumber) => {
    this.setState({ inAppPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };

  handleBlankPageChange = (pageNumber) => {
    this.setState({ blankPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };
 
  handleDesktopPageChange = (pageNumber) => {
    this.setState({ desktopPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };

  handleUserDocPageChange = (pageNumber) => {
    this.setState({ userDocPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };

  handleUserOnPageChange = (pageNumber) => {
    this.setState({ userOnPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };

  handleWebAutoPageChange = (pageNumber) => {
    this.setState({ webAutoPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };

  handleImportPageChange = (pageNumber) => {
    this.setState({ importPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };

  handleWorkflowPageChange = (pageNumber) => {
    this.setState({ workflowPage: pageNumber, isLoading: true });
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pageNumber);
    window.history.replaceState({}, '', `${window.location.pathname}?${queryParams.toString()}`);
    this.getSkillsByTemplate(pageNumber)
  };

  searchSkillStore = (e) => {
    this.setState({
      searchItem: e.target.value,
    });
    this.props.setSearchQuery(e.target.value);
  };

  onKeyPress = (e) => {
    if (e.key === "Enter") {
      this.setState({
        isSearching: true,
      });
      this.props.history.push({
        pathname: `/dashboard/skills/search/draft?query=${this.state.searchItem}`,
      });
      this.props.setSearchQuery(this.state.searchItem);
    }
  };

  handleSelectChange = (value, pageNumber) => {
    this.props.setSelectedFilter(value);
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete('page');
    const queryString = queryParams.toString();
    const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
    this.setState({ checked: value, displayContent: "", createdBy: "", skills: [], isLoading: true }, () => {
      switch (value) {
        case 'all':
          this.getDraftSkill(pageNumber);
          break;
        case 'published':
          this.getFilteredSkill(pageNumber);
          break;
        case 'draft':
          this.getFilteredSkill(pageNumber);
          break;
        case 'pending':
          this.getFilteredSkill(pageNumber);
          break;
        case 'byUser':
          this.setState({ isLoading: true })
          this.props.setSelectedFilter("all");
          this.getDraftSkill(pageNumber)
          break;
        case 'byTemplate':
          this.setState({ isLoading: true });
          this.props.setSelectedFilter("all");
          this.getDraftSkill(pageNumber)
          break;
        default:
          // Handle default case if needed
          break;
      }
    })
  

  };

  handleTemplateChange = (event) => {
    const value = event.target.value;
    this.setState({selectedTemplate: value})
    this.props.setSelectedTemplate(value);
  };

   handleUserSubmit = async () => {
    if(this.state.createdBy === "CreatedBy Me") {
    this.setState({ checked: "CreatedBy Me"})
    }
    const queryParams = new URLSearchParams(window.location.search);
    let userPage = parseInt(queryParams.get('page')) || 1;
    const mainEmail = this.props?.userReducer?.user?.email;
    const filter = this.props?.skillReducer?.selectedFilter
    const pageSize = 9;
    const data = { page: userPage, pageSize };
    const currentOrgId =
      this.props?.organizationReducer?.currentOrgUser?.organization_id;
    const userDraftSkill = await this.props.retrieveMySkills(
      mainEmail,
      data,
      currentOrgId
    );
    if (userDraftSkill) {
      const content = `${filter? filter: ""}`
      if (userDraftSkill?.results) {
        this.setState({
          isLoading: false,
          skills: userDraftSkill.results,
          isScrolling: false,
          displayContent: content,
          checked: "byUser",
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  getSkillsByUserEmail = async () => {
    if(this.state.createdBy === "CreatedBy") {
    this.setState({ checked: "CreatedBy"})
    }
    const queryParams = new URLSearchParams(window.location.search);
    let otherUserPage = parseInt(queryParams.get('page')) || 1;
    const { createdBy } = this.state;
    const email = this.props?.skillReducer?.userEmail
    const pageSize = 9;
    const data = { page: otherUserPage, pageSize };
    const currentOrgId = this.props?.organizationReducer?.currentOrgUser?.organization_id;
    const userDraftSkill = await this.props.retrieveDraftByEmail(data, currentOrgId, email);
    if (userDraftSkill) {
      const content = email ? email : (createdBy ? `${createdBy}:` : "");
      if (userDraftSkill?.results) {
        this.setState({
          isLoading: false,
          skills: userDraftSkill.results,
          isScrolling: false,
          displayContent: content,
          checked: "byUser",
        });
      } else {
        this.setState({
          isLoading: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  handleCreatedByChange = (value) => {
    this.props.setSelectedFilter(value)
    this.setState({
      createdBy: value,
      userEmail: "",
    });
  };

  getUniqueTemplates = async () => {
    this.setState({ isTemplateLodaing: true });
    const userDraftSkill = await this.props.retrieveAllTemplates();
    if (userDraftSkill) {
      if (userDraftSkill.results.length) {
        this.setState({
          isLoading: false,
          isTemplateLodaing: false,
          uniqueSkills: userDraftSkill?.results,
          isScrolling: false,
        });
      } else {
        this.setState({
          isLoading: false,
          isTemplateLodaing: false,
          hasMore: false,
          isScrolling: false,
        });
      }
    } else {
      this.setState({
        isLoading: false,
        isTemplateLodaing: false,
        hasMore: false,
        isScrolling: false,
      });
    }
  };

  validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };

  render() {
    const { uniqueSkills, createdBy } = this.state;
    const uniqueTemplateNamesSet = new Set();
    if (uniqueSkills && uniqueSkills.length > 0) {
      uniqueSkills.forEach((skill) => {
        if (skill && skill.TEMPLATE) {
          uniqueTemplateNamesSet.add(skill.TEMPLATE);
        }
      });
    }
    const uniqueTemplateNamesArray = Array.from(uniqueTemplateNamesSet);
    const queryParams = new URLSearchParams(window.location.search);
    const urlParams = new URLSearchParams(this.props.history.location.search);
    const AllPage = parseInt(urlParams.get('page')) || 1;
    const publishedPage = parseInt(queryParams.get('page')) || 1;
    const draftPage = parseInt(queryParams.get('page')) || 1;
    const pendingPage = parseInt(queryParams.get('page')) || 1;
    const userPage = parseInt(queryParams.get('page')) || 1;
    const otherUserPage = parseInt(queryParams.get('page')) || 1;
    const inAppPage = parseInt(queryParams.get('page')) || 1;
    const blankPage = parseInt(queryParams.get('page')) || 1;
    const webAutoPage = parseInt(queryParams.get('page')) || 1;
    const importPage = parseInt(queryParams.get('page')) || 1;
    const userOnPage = parseInt(queryParams.get('page')) || 1;
    const userDocPage = parseInt(queryParams.get('page')) || 1;
    const desktopPage = parseInt(queryParams.get('page')) || 1;
    const workflowPage = parseInt(queryParams.get('page')) || 1;
    const filter = this.props?.skillReducer?.selectedFilter
    const template = this.props?.skillReducer?.selectedTemplate
    return (
      <React.Fragment>
        {/* Draft Skill */}
        <div className="task-col-search">
          <div className="row mx-0 setting-search bg-white py-3 border-left">
            <div className="col-md-8">
              <div className="position-relative search">
                <input
                  id="searchField"
                  type="search"
                  placeholder="Search"
                  className="form-control border-0"
                  value={this.state.searchItem ? this.state.searchItem : ""}
                  onChange={(e) => this.searchSkillStore(e)}
                  onKeyDown={(e) => this.onKeyPress(e)}
                />
                {/* <img src={SearchIcon} alt="Search" /> */}
              </div>
            </div>
          </div>

          <div
            id="templateModal"
            className="modal fade crt-skill"
            role="dialog"
            data-keyboard="false"
            data-backdrop="static"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <div class="modal-dialog">
              <div class="modal-content crt-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    onClick={() => {
                      this.props.setSelectedTemplate("")
                    }}
                  >
                    &times;
                  </button>
                  <h4 class="modal-title"> By Template</h4>
                </div>
                <div class="modal-body">
                  <form class="form-contain" action="javascript:void(0)">
                    <div class="frm-block">
                      <select
                        value={this.props.selectedTemplate}
                        onChange={this.handleTemplateChange}
                      >
                        <option value="" disabled={this.state.isLoading}>
                          {this.state.isTemplateLodaing &&
                          uniqueTemplateNamesArray.length === 0
                            ? "Loading..."
                            : "Select Template"}
                        </option>
                        {uniqueTemplateNamesArray
                          .filter(
                            (templateName) => templateName !== "Skill Set" && templateName !== "Process Discovery"
                          ) // Exclude "skill set"
                          .map((templateName) => (
                            <option key={templateName} value={templateName}>
                              {templateName === "GenAi Automation" ? "Workflow AI Agent" : templateName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div class="frm-btns">
                      <button
                        class="btn btn-outline"
                        data-dismiss="modal"
                        onClick={() => {
                          this.props.setSelectedTemplate("")
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        class="btn btn-primary"
                        data-dismiss="modal"
                        onClick={() => {
                          this.setState({ isLoading: true }, () => {
                            this.getSkillsByTemplate();
                          });
                        }}
                      >
                        {this.state.isLoading ? (
                          <div class="sp sp-circle text-light"></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div
            id="userModal1"
            class="modal fade crt-skill"
            role="dialog"
            data-keyboard="false"
            data-backdrop="static"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <div class="modal-dialog">
              <div class="modal-content crt-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    onClick={() => this.props.setUserEmail("")}
                  >
                    &times;
                  </button>
                  <h4 class="modal-title">By User</h4>
                </div>
                <div class="modal-body">
                  <form class="form-contain" action="javascript:void(0)">
                    <div className="frm-block">
                      <div className="frm-radio-box">
                        <div className="frm-radio-item">
                          <input
                            type="radio"
                            value="CreatedBy Me"
                            checked={createdBy === "CreatedBy Me"}
                            onChange={() =>
                              this.handleCreatedByChange("CreatedBy Me")
                            }
                            id="CreatedBy Me"
                          />
                          <label for="CreatedBy Me">Created by Me</label>
                        </div>
                        <div className="frm-radio-item">
                          <input
                            type="radio"
                            value="CreatedBy"
                            checked={createdBy === "CreatedBy"}
                            onChange={() =>
                              this.handleCreatedByChange("CreatedBy")
                            }
                            id="CreatedBy"
                          />
                          <label for="CreatedBy">Created by Other User</label>
                        </div>
                      </div>
                      <div className="frm-email-input">
                        {createdBy === "CreatedBy" && (
                          <input
                            type="text"
                            placeholder="Enter email"
                            ref={this.emailInputRef}
                            value={this.props.userEmail}
                            onChange={(e) => this.props.setUserEmail(e.target.value)}
                          />
                        )}
                      </div>
                    </div>
                    <div class="frm-btns">
                      <button
                        class="btn btn-outline"
                        data-dismiss="modal"
                        onClick={() => this.props.setUserEmail("")}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        data-dismiss="modal"
                        onClick={() => {
                          this.setState({ isLoading: true }, () => {
                            if (this.state.createdBy === "CreatedBy Me") {
                              this.handleUserSubmit();
                            } else {
                              this.getSkillsByUserEmail();
                            }
                          });
                        }}
                      >
                        {this.state.isLoading ? (
                          <div className="sp sp-circle text-light"></div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="task-col">
            <div className="title-btn tab-title-btn">
              {/* <h1 className="title">Created By Team</h1> */}
              <div className="title-tabs">
                <button
                  className="btn btn-default active"
                  onClick={() => {
                    this.props.changeActiveTab("Created By Team");

                    this.props.history.push("/dashboard/skills/draft");
                    this.props.changeMode(false);
                  }}
                >
                  Created by Team
                </button>
                <button
                  className="btn btn-default"
                  onClick={() => {
                    this.props.changeActiveTab("Added From Agent Hub");

                    this.props.history.push("/dashboard/skills/published");
                    this.props.changeMode(false);
                  }}
                >
Added From Agent Hub                </button>

                {/* Process Discovery */}
                <button
                  className="btn btn-default"
                  onClick={() => {
                    this.props.changeActiveTab("Process Discovery");

                    this.props.history.push(
                      "/dashboard/skills/process-discovery"
                    );
                    this.props.changeMode(false);
                  }}
                >
                  Process Discovery
                </button>
              </div>
              
              <div className="radio-btns filter-row">
                <div className="filter-sort">
                  <Select
                    //defaultValue="Filter By"
                    value={this.props?.skillReducer?.selectedFilter}
                    style={{
                      width: 120,
                    }}
                    options={[
                      {
                        value: "all",
                        label: "Filters",
                      },
                      {
                        value: "byTemplate",
                        label: (
                          <span
                            data-toggle="modal"
                            data-target="#templateModal"
                            onClick={this.getUniqueTemplates}
                          >
                            By Template
                          </span>
                        ),
                      },
                      {
                        value: "byUser",
                        label: (
                          <span data-toggle="modal" data-target="#userModal1">
                            By User
                          </span>
                        ),
                      },
                      {
                        value: "published",
                        label: "Published",
                      },
                      {
                        value: "draft",
                        label: "Draft",
                      },
                      {
                        value: "pending",
                        label: "Pending",
                      },
                    ]}
                    onChange={this.handleSelectChange}
                  />
                  {this.state.displayContent ? (
                    <div className="filter-badge">
                      <span>{this.state.displayContent==="GenAi Automation"?"Workflow AI Agent":this.state.displayContent}</span>
                      {/* <button className="close"
                        >
                        X
                      </button> */}
                         <Button
                          onClick={() => {
                            this.setState({ isLoading: true, createdBy: "", checked: "all", displayContent: "" });
                            this.props.setSelectedFilter("all")
                            this.props.setSelectedTemplate("all")
                            this.getDraftSkill();
                          }}
                          shape="circle"
                          icon={<CloseOutlined />} />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>

            {filter === 'all' ? (
              <div id="scrollableDiv" className="scrollable tl-scroll">
                {this.state.isLoading ? (
                  <Loader
                    styles={{ width: "80px", margin: "auto" }}
                    root={{ display: "flex" }}
                  />
                ) : (
                  <div>
                    {this.state.isLoading === false &&
                    !this.state.skills.length ? (
                      <div>
                        <EmptyLoader
                          style={{ width: "30%" }}
                          message="No Agents found"
                        />
                      </div>
                    ) : (
                      <div>
                        {this.state.skills.map((item, key) => (
                          <MyDraftItem
                            color={getColors(item.SKILL_NAME)}
                            key={key}
                            skill={item}
                            {...this.props}
                            deleteDraftSkill={this.deleteDraftSkill}
                          />
                        ))}
                        <div className="template-flex">
                          <div className="template-box scrollable">
                            {template === 'In-App Walkthrough' ? (
                              <Pagination
                                current={inAppPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleInAppPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : template === 'Blank Template' ? (
                              <Pagination
                                current={blankPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleBlankPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : template === 'UserDocumentation' ? (
                              <Pagination
                                current={userDocPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleUserDocPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : template === 'UserOnboarding' ? (
                              <Pagination
                                current={userOnPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleUserOnPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : template === 'WebAutomation' ? (
                              <Pagination
                                current={webAutoPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleWebAutoPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : template === 'Import Data from Spreadsheet to Web App' ? (
                              <Pagination
                                current={importPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleImportPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : template === 'Desktop Walkthrough' ? (
                              <Pagination
                                current={desktopPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleDesktopPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : template === 'GenAi Automation' ? (
                              <Pagination
                                current={workflowPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleWorkflowPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            ) : (
                              <Pagination
                                current={AllPage}
                                pageSize={9}
                                total={this.props.totalCount}
                                onChange={this.handlePageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              ) : filter === 'draft' ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Agents found"
                            />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={draftPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handleDraftPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === 'pending' ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Agents found"
                            />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={pendingPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handlePendingPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === "CreatedBy Me" ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Agents found"
                            />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={userPage}
                                pageSize={9}
                                total={this.props.allCount}
                                onChange={this.handleUserPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === "CreatedBy" ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Agents found"
                            />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={otherUserPage}
                                pageSize={9}
                                total={this.props.skillByEmailCount}
                                onChange={this.handleOtherUserPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : filter === "published" ? (
                <div id="scrollableDiv" className="scrollable tl-scroll">
                  {this.state.isLoading ? (
                    <Loader
                      styles={{ width: "80px", margin: "auto" }}
                      root={{ display: "flex" }}
                    />
                  ) : (
                    <div>
                      {this.state.isLoading === false && !this.state.skills.length ? (
                        <div>
                          <EmptyLoader
                            style={{ width: "30%" }}
                            message="No Agents found"
                            />
                        </div>
                      ) : (
                        <div>
                          {this.state.skills
                            .map((item, key) => (
                              <MyDraftItem
                                color={getColors(item.SKILL_NAME)}
                                key={key}
                                skill={item}
                                {...this.props}
                                deleteDraftSkill={this.deleteDraftSkill}
                              />
                            ))}
                          <div className="template-flex">
                            <div className="template-box scrollable">
                              <Pagination
                                current={publishedPage}
                                pageSize={9}
                                total={this.props.filteredCount}
                                onChange={this.handlePublishedPageChange}
                                hideOnSinglePage={false}
                                showSizeChanger={false}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) :  ""}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  skills: state.skillReducer,
  userReducer: state.userReducer,
  skillReducer: state.skillReducer,
  searchTerm: state.searchTerm,
  appReducer: state.appReducer,
  snackReducer: state.snackReducer,
  organizationReducer: state.organizationReducer,
  totalCount: state.skillReducer.totalCount,
  skillByEmailCount: state.skillReducer.skillByEmailCount,
  filteredCount: state.skillReducer.filteredCount,
  allCount: state.skillReducer.allCount,
  userEmail: state.skillReducer.userEmail,
  selectedTemplate: state.skillReducer.selectedTemplate
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getSkillsFromStore,
    addSkillToUser,
    filterSearchItem,
    notify,
    getDraftSkills,
    deleteDraftSkill,
    clearDraft,
    retrieveFilteredSkill,
    changeActiveTab,
    retrieveAllTemplates,
    retrieveDraftByEmail,
    retrieveMySkills,
    changeMode,
    setSelectedFilter,
    setUserEmail,
    setSelectedTemplate,
    setSearchQuery
  })
)(MyDraftSkills);
